import { useMemo } from 'react';

import { usePrivateContextSourcesList } from '~/components/v2/hooks/queries/usePrivateContextSourcesList';
import { usePrivateContextSourcesPermissions } from '~/components/v2/hooks/usePrivateContextSourcesPermissions';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export function useCanEditContextSources() {
  const { generativeCanvasEnabled } = useTemporaryFeatureFlags();
  const { currentWorkspace } = useCurrentWorkspace();
  const { data: contextSources } = usePrivateContextSourcesList({
    workspaceId: currentWorkspace?.id,
  });
  const { canEdit } = usePrivateContextSourcesPermissions();

  return useMemo(
    () => ({
      canEditContextSources: canEdit && !!contextSources?.data?.length && generativeCanvasEnabled,
    }),
    [canEdit, contextSources?.data, generativeCanvasEnabled],
  );
}
